module.exports = __webpack_public_path__ + "img/video-bck.ac906616.png";